import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=39d10a3a&"
import script from "./OrderPage.ts?vue&type=script&lang=js&"
export * from "./OrderPage.ts?vue&type=script&lang=js&"
import style0 from "./OrderPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports